import { Product } from "./product.model";

export const products: Product[] = [
  {
    id: "CPX",
    desc: {
      en: {
        productCodeDesc: "RBC Avion Visa Business"
      },
      fr: {
        productCodeDesc: "Avion Visa Affaires RBC"
      }
    }
  },
  {
    id: "AIB",
    desc: {
      en: {
        productCodeDesc: "RBC Avion Visa Infinite Business"
      },
      fr: {
        productCodeDesc: "Avion Visa Infinite Affaires RBC"
      }
    }
  },
  {
    id: "CLX",
    desc: {
      en: {
        productCodeDesc: "RBC Visa Business"
      },
      fr: {
        productCodeDesc: "Visa Affaires RBC"
      }
    }
  },
  {
    id: "MC6",
    desc: {
      en: {
        productCodeDesc: "RBC Business Cash Back Mastercard"
      },
      fr: {
        productCodeDesc: "Remise en argent Affaires Mastercard RBC"
      }
    }
  },
    {
    id: "MCB",
    desc: {
      en: {
        productCodeDesc: "WestJet World Elite MasterCard for Business"
      },
      fr: {
        productCodeDesc: "WestJet World Elite Mastercard d’entreprise RBC"
      }
    }
  },

];
